export default __webpack_public_path__ + "static/media/electrotech.77924481.pdf";